export function About(props){
    return (
            <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
                <h2>About Us</h2>
                We are mountain biking passionates residing in Costa Rica since 1977. Our childhood was surrounded by mountains and trails, and our mode of entertainment was to ride a bike. Today, nearly five decades afterwards, we benefit from riding the bike to the grocery store, to the work, wherever there is a must, we go there in bicycle. It has shown to be good on your health, your mood, your state of mind. And that is why we want to share our passion with you.
                <br />
            </div>
        );
}
